import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { CbreLogger, CbreLoggerToken } from '../logger/logger.model';

/**
 * Angular ErrorHandler implementation to use Logger instance to
 * log the values. Logger uses configured TransportTemplates and Transporters
 * to log captured errors
 */
@Injectable()
export class CbreErrorHandler implements ErrorHandler {
  constructor(@Inject(CbreLoggerToken) private logger: CbreLogger) {}

  handleError(error: Error | HttpErrorResponse): void {
    this.logger.error(error);
  }
}
